import { Injectable } from '@angular/core';
import { ApiRequestService } from '../api-request/api-request.service';
import { BehaviorSubject } from 'rxjs';
import OrganizationUnit from 'models/organization-unit/organization-unit.model';
import ApiResponse from 'models/api-response/api-response.model';
import { LogService } from '../log/log.service';
import Log from 'models/log/log.model';
import EsriLayer from 'models/esri-layer/esri-layer.model';
import EsriService from 'models/esri-service/esri-service.model';
import { TokenService } from 'services/token/token-service.service';

@Injectable({
    providedIn: 'root'
})
export class OrganizationUnitService {
    private ouList: BehaviorSubject<OrganizationUnit[]> = new BehaviorSubject([]);
    constructor(
      public apiRequestService: ApiRequestService,
      public logService: LogService,
      public tokenService: TokenService
    ) { }

    public async list() {
        return new Promise((resolve: (r: OrganizationUnit[]) => any, reject: (e: Error) => any) => {
            this.apiRequestService.post('/ou/list', {}).subscribe({
                next: async (res: ApiResponse<OrganizationUnit[]>) => {
                    if (!res.success) {
                        await this.logService.create(new Log({
                            description: 'requestError: ' + JSON.stringify(res),
                            event: 'serviceError',
                            performer: 'OrganizationUnitService.list',
                            type: 'error'
                          }));
                        return reject(new Error('requestError'));
                    }
                    const resArr: OrganizationUnit[] = [];
                    for (let i = 0; i < res.data.length; i++) {
                      resArr.push(new OrganizationUnit(res.data[i]));
                    }
                    this.ouList.next(resArr);
                    return resolve(resArr);
                },
                error: async error => {
                  this.tokenService.removeOidcData();
                  location.reload();
                  await this.logService.create(new Log({
                    description: error,
                    event: 'serviceError',
                    performer: 'OrganizationUnitService.list',
                    type: 'error'
                  }));
                  return reject(new Error('requestError'));
                }
              });
        });
    }

    public async update(ou: OrganizationUnit) {
        return new Promise((resolve: (r: OrganizationUnit) => any, reject: (e: Error) => any) => {
            this.apiRequestService.put('/ou', {
                name: ou.name,
                niceName: ou.niceName
            }).subscribe({
                next: async (res: ApiResponse<OrganizationUnit>) => {
                    if (!res.success) {
                        await this.logService.create(new Log({
                            description: 'requestError: ' + JSON.stringify(res),
                            event: 'serviceError',
                            performer: 'OrganizationUnitService.update',
                            type: 'error'
                          }));
                        return reject(new Error('requestError'));
                    }
                    return resolve(new OrganizationUnit(res.data));
                },
                error: async error => {
                  console.log(error);
                  await this.logService.create(new Log({
                    description: error,
                    event: 'serviceError',
                    performer: 'OrganizationUnitService.update',
                    type: 'error'
                  }));
                  return reject(new Error('requestError'));
                }
              });
        });
    }

    public async addLayer(ou: OrganizationUnit, layerUrls: string[]) {
      return new Promise((resolve: (r: boolean) => any, reject: (e: Error) => any) => {
          this.apiRequestService.post('/ou/addlayer', {
              organizationUnit: ou.name,
              externalLayers: layerUrls
          }).subscribe({
              next: async (res: ApiResponse<boolean>) => {
                  if (!res.success) {
                      await this.logService.create(new Log({
                          description: 'requestError: ' + JSON.stringify(res),
                          event: 'serviceError',
                          performer: 'OrganizationUnitService.update',
                          type: 'error'
                        }));
                      return reject(new Error('requestError'));
                  }
                  return resolve(true);
              },
              error: async error => {
                console.log(error);
                await this.logService.create(new Log({
                  description: error,
                  event: 'serviceError',
                  performer: 'OrganizationUnitService.addLayer',
                  type: 'error'
                }));
                return reject(new Error('requestError'));
              }
            });
      });
  }

  public async removeLayer(ou: OrganizationUnit, layerUrl: string) {
    return new Promise((resolve: (r: boolean) => any, reject: (e: Error) => any) => {
        this.apiRequestService.post('/ou/removelayer', {
            organizationUnit: ou.name,
            externalLayer: layerUrl
        }).subscribe({
            next: async (res: ApiResponse<boolean>) => {
                if (!res.success) {
                    await this.logService.create(new Log({
                        description: 'requestError: ' + JSON.stringify(res),
                        event: 'serviceError',
                        performer: 'OrganizationUnitService.update',
                        type: 'error'
                      }));
                    return reject(new Error('requestError'));
                }
                return resolve(true);
            },
            error: async error => {
              console.log(error);
              await this.logService.create(new Log({
                description: error,
                event: 'serviceError',
                performer: 'OrganizationUnitService.addLayer',
                type: 'error'
              }));
              return reject(new Error('requestError'));
            }
          });
    });
  }

    getOuList() { return this.ouList; }
}
